import { prefetchModelShow } from '@rhino-project/core/hooks';
import { NotFoundPage } from '@rhino-project/ui-heroui';
import { createFileRoute } from '@tanstack/react-router';
import SeasonPlayerPage from '../../../../../../pages/players/SeasonPlayerPage';

export const Route = createFileRoute(
  '/_authenticated/$owner/active/$team_season_id/players/$id/'
)({
  loader: ({ context: { rhino }, params: { id } }) =>
    prefetchModelShow(rhino, 'player', id),
  component: RouteComponent,
  notFoundComponent: NotFoundPage
});

function RouteComponent() {
  return <SeasonPlayerPage />;
}
